// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__ELzMy","foooter":"style_foooter__DhzrS"};